import { __rest, __assign } from 'tslib';
import React__default, { useRef } from 'react';
import { PlayIcon } from '../../assets/icons/PlayIcon.esm.js';
import classNames from 'classnames';
import { NvButton } from '@invitae/ids-react';
import { VideoPopup } from './VideoPopup/VideoPopup.esm.js';
import styles from './VideoPopupLink.module.esm.js';

var VideoPopupLink = function (_a) {
    var children = _a.children, vimeoId = _a.vimeoId, classes = _a.classes, rootElementProps = __rest(_a, ["children", "vimeoId", "classes"]);
    var dialogRef = useRef(null);
    var handleOpenPopup = function () { var _a; return (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.showModal(); };
    var handleClosePopup = function () { var _a; return (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.close(); };
    if (!vimeoId)
        return null;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(VideoPopup, { closeVideoPopup: handleClosePopup, ref: dialogRef, vimeoId: vimeoId }),
        React__default.createElement(NvButton, __assign({}, rootElementProps, { className: classNames(classes, styles.link), onClick: handleOpenPopup }),
            children,
            " ",
            React__default.createElement(PlayIcon, null))));
};

export { VideoPopupLink };
//# sourceMappingURL=VideoPopupLink.esm.js.map
